// Centralized GA4 analytics via GTM dataLayer. Never push PII (email, name, employee ID).
// All functions are no-ops if GTM is not loaded.

function pushEvent(eventName, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...params });
}

export function trackVirtualPageView(pagePath, pageTitle) {
  pushEvent('virtual_page_view', { page_path: pagePath, page_title: pageTitle });
}

export function trackNavClick(tabName, userTier) {
  pushEvent('nav_tab_click', { tab_name: tabName, user_tier: userTier });
}

export function trackPeriodChange(periodValue, pageContext) {
  pushEvent('period_change', { period_value: periodValue, page_context: pageContext });
}

export function trackDrillDown(drillLevel, entityType) {
  pushEvent('drill_down', { drill_level: drillLevel, entity_type: entityType });
}

export function trackExport(reportType, format) {
  pushEvent('export_report', { report_type: reportType, format });
}

export function trackBudgetAction(actionType) {
  pushEvent('budget_action', { action_type: actionType });
}

export function trackOutcomeAction(actionType, outcomeStatus) {
  pushEvent('outcome_action', { action_type: actionType, outcome_status: outcomeStatus });
}

export function trackPersonSearch(hasResults) {
  pushEvent('search_person', { has_results: hasResults });
}

export function trackError(errorType, endpoint) {
  pushEvent('error_state', { error_type: errorType, endpoint });
}

export function trackThemeToggle(newTheme) {
  pushEvent('theme_toggle', { new_theme: newTheme });
}

// Push non-PII user properties after authentication. GA4 uses these for segmentation.
export function setUserProperties(properties) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'user_properties_set',
    user_properties: {
      portal_tier: properties.portalTier,
      user_role: properties.userRole,
      is_admin: properties.isAdmin,
      is_super_admin: properties.isSuperAdmin,
    },
  });
}
